module.exports = __webpack_public_path__ + "static/media/checkout-old-mobile.4957e58c.png";